import { useContext, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { DatosInicioContext } from "../../context/DatosInicioContext";
import formatearValores from "../../helpers/formatearAPeso";
import formatearFecha from "../../helpers/formatearFecha";
import { getToken } from "../../utils/auth";
import { normalizeOrdenPagoPayload } from "../../helpers/aliadosApiShape";
import { renderOrdenPagoNuevo } from "../../helpers/ordenPagoPdf";

const buildFilename = (comercio, tipoTarjeta, fecha) => {
  const nombre = String(comercio || "orden_pago").replace(/[^a-z0-9]/gi, "_");
  const tipo = tipoTarjeta === "QR" ? "_QR" : tipoTarjeta === "NARANJA S" ? "_NARANJA" : "_GENERAL";
  return `OrdenPago_${nombre}${tipo}_${fecha}.pdf`;
};

const ItemsTablaTicket = ({ fecha, costoFinancieroEn, totalBruto, arancel, iva21, retencionIva, impuestoDebitoCredito, retencionProvincial, retencionGanacia, totalConDescuentos }) => {
  const { darkMode } = useContext(DarkModeContext);
  const { datos } = useContext(DatosInicioContext);
  const comercioSeleccionado = datos?.comercio;
  const valoresFormateados = formatearValores(totalBruto, costoFinancieroEn, arancel, iva21, impuestoDebitoCredito, iva21, impuestoDebitoCredito, retencionProvincial, retencionGanacia, retencionIva, totalConDescuentos);
  const fechaFormateada = formatearFecha(fecha);
  const [descargando, setDescargando] = useState(false);

  const generarOrdenDePago = async () => {
    setDescargando(true);
    try {
      const respuesta = await fetch(process.env.REACT_APP_API_PDF_ORDEN_PAGO, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Token: getToken(), FechaPago: fechaFormateada, Comercio: comercioSeleccionado }),
      });
      if (!respuesta.ok) throw new Error("Error al obtener datos del backend");
      const payload = normalizeOrdenPagoPayload(await respuesta.json());
      for (const comercio of payload.comercios || []) {
        for (const tipo of comercio.tiposTarjeta || []) {
          renderOrdenPagoNuevo({ comercioData: comercio, tipoData: tipo, fechaPago: fechaFormateada, filename: buildFilename(comercio.comercio, tipo.tipoTarjeta, fechaFormateada) });
        }
      }
    } catch (error) {
      console.error("Error al generar PDF:", error);
    } finally {
      setDescargando(false);
    }
  };

  return (
    <tr className={darkMode ? "tabla-borde-bottom text-white" : "tabla-borde-bottom text-dark"}>
      <td className="fs-12-a-10 lato-regular py-3 priority-1">{fechaFormateada}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-2">$ {valoresFormateados[0]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-3">$ {valoresFormateados[1]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-4">$ {valoresFormateados[2]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-5">$ {valoresFormateados[3]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-6">$ {valoresFormateados[4]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-7">$ {valoresFormateados[7]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-8">$ {valoresFormateados[8]}</td>
      <td className="fs-12-a-10 lato-regular py-3 priority-9">$ {valoresFormateados[9]}</td>
      <td className="fs-12-a-10 lato-regular priority-1">${valoresFormateados[10]}</td>
      <td className="fs-12-a-10 lato-regular priority-1">
        <button type="button" className="btn-slide-descargar" onClick={generarOrdenDePago} disabled={descargando}>
          {descargando ? "Generando..." : <><FontAwesomeIcon icon={faDownload} className="aliado-descarga-icono" aria-hidden="true" /><span className="aliado-descarga-texto">Descargar Orden</span></>}
        </button>
      </td>
    </tr>
  );
};

export default ItemsTablaTicket;
